import React from 'react';
import { StyleSheet, View } from 'react-native';
import { BodyText, useResponsive } from '@sweetgreen/garnish';

import { useLocalizationContext } from '@order/Localization';
import { getAppVersion } from '@order/utils';

export const OrganizationLinksFooterCopyright = () => {
  const { t } = useLocalizationContext();
  const { match } = useResponsive();

  const textStyle = match([undefined, styles.copyrightAndAppVersionText]);

  return (
    <View>
      <BodyText style={textStyle}>
        {t('footer.copyright', { year: CURRENT_YEAR })}
      </BodyText>

      <BodyText style={textStyle}>{APP_VERSION}</BodyText>
    </View>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const APP_VERSION = `v${getAppVersion()}`;
const CURRENT_YEAR = new Date().getFullYear();

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  copyrightAndAppVersionText: {
    textAlign: 'right',
  },
});
